import { animate, style, transition, trigger } from '@angular/animations';

export const ERROR_ANIMATION = trigger('smoothappear', [
  transition(':enter', [
    style({
      height: '0px',
      paddingTop: '0px',
      paddingBottom: '0px',
      marginTop: '0px',
      marginBottom: '0px',
      opacity: 0
    }),
    animate(
      '250ms 1500ms ease',
      style({
        opacity: 1,
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        marginTop: '*',
        marginBottom: '*'
      })
    )
  ]),
  transition(':leave', [
    animate(
      '250ms ease',
      style({
        opacity: 0,
        height: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginBottom: '0px',
        marginTop: '0px'
      })
    )
  ])
]);
